import Button from '@/components/ui/button';

type Props = {
	submit: (id: string) => void;
	closeModal: () => void;
	message: string;
	elementId?: string;
};

const ConfirmDeleteModalString = ({
	submit,
	closeModal,
	message,
	elementId,
}: Props) => {
	const handleConfirmDelete = () => {
		if (elementId) {
			submit(elementId);
			closeModal();
		}
	};
	return (
		<div
			className="w-fit flex flex-col items-center gap-4 p-4"
			data-test="confirm-delete-modal"
		>
			<div className="w-[400px] text-center">{message}</div>
			<div className="flex gap-5">
				<div>
					<Button
						className="w-[100px]"
						onClick={closeModal}
						data-test="confirm-no-button"
					>
						No
					</Button>
				</div>
				<div>
					<Button
						className="w-[100px]"
						onClick={handleConfirmDelete}
						data-test="confirm-yes-button"
					>
						Yes
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmDeleteModalString;
